<template>
  <div :class="['language',showOnDesktop == false ? 'language__off--desktop' :'']">
    <div class="language-change">
      <span
        v-for="(language, index) in languages"
        :key="index"
        :class="[
          'language-change__option',
          {
            'language-change__option--selected':
              language.desc === selectedLanguage
          }
        ]"
        @click="selectLanguage(language)"
      >
        {{ language.desc }}
      </span>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'

  const i18n = useI18n()

  const languages = [
    { code: 'ca', desc: 'CAT' },
    { code: 'es', desc: 'ESP' },
    { code: 'en', desc: 'ENG' }
  ]

  const selectedLanguageObject = languages.find(
    (language) => language.code === i18n.locale.value
  )

  const selectedLanguage = ref(selectedLanguageObject.desc || 'ESP')
  const selectLanguage = (language) => {
    selectedLanguage.value = language.desc
    i18n.locale.value = language.code
  }

  defineProps({
    flexJustify: { type: String, default: 'flex-end' },
    showLogo: { type: Boolean, default: true },
    color: { type: String, default: 'var(--theme-color)' },
    padding: { type: String, default: '30px' },
    showOnDesktop: { type: Boolean, default: true },

  })
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .language {
    @include d-flex(row, v-bind(flexJustify), center);
    gap: 15px;
    padding: v-bind(padding);
    width: 100%;
    height: auto;
    font-size: 14px;
    &__off--desktop{
      @media screen and (min-width: $sm-breakpoint) {
        display: none;
      }
    }
  }

  .language-change {
    &__option {
      color: v-bind(color);
      padding-left: 5px;
      cursor: pointer;

      &:not(:last-child)::after {
        content: '';
        padding-right: 5px;
        border-right: 2px solid v-bind(color);
      }

      &--selected {
        font-weight: 800;
        text-decoration: none;
      }

      &:not(.language-change__option--selected) {
        text-decoration: underline;
        text-underline-offset: 8px;
      }
    }
  }
</style>
